// 1000.00 -> 1 000.00
export const formatPrice = (num: number, digits = 0) => {
  const spacesRegex = /\B(?=(\d{3})+(?!\d))/g
  let value = ''
  if (num === null || num === undefined) {
    return '0.00'
  }

  if (typeof num === 'number') {
    value = num.toFixed(digits).replace(spacesRegex, ' ')
  } else if (typeof num === 'string') {
    value = parseFloat(num).toFixed(digits).replace(spacesRegex, ' ')
  }

  return `${value}`
}

// Форматирует цену: если дробная часть состоит из одной цифры, добавляет нуль (19.9 -> 19.90)
export const formatPriceWithTwoDecimals = (price: number | string): string => {
  const numPrice = Number(price)
  if (isNaN(numPrice)) {
    return String(price)
  }
  if (Number.isInteger(numPrice)) {
    return numPrice.toString()
  }
  const str = numPrice.toString()
  const decimalPart = str.split('.')[1]
  if (decimalPart && decimalPart.length === 1) {
    return numPrice.toFixed(2)
  }
  return str
}

export const Plurize = (number: number, one: string, two: string, five: string) => {
  let n = Math.abs(number)
  n %= 100
  if (n >= 5 && n <= 20) {
    return five
  }
  n %= 10
  if (n === 1) {
    return one
  }
  if (n >= 2 && n <= 4) {
    return two
  }
  return five
}
